import { render, staticRenderFns } from "./HeaderFour.vue?vue&type=template&id=f6158c28&"
import script from "./HeaderFour.vue?vue&type=script&lang=js&"
export * from "./HeaderFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports